import React from 'react'
import { Box, BoxProps, Spacer } from '@chakra-ui/react'

import SharedLabel from '~components/shared/form/shared-label'
import SharedStack from '~components/shared/wrappers/shared-stack'

interface Props {
    icon?: React.ReactNode
    title: string
    headerAction?: React.ReactNode
    bodyProps?: BoxProps
    children: React.ReactNode
}

export default function DashboardSectionCard({
    children,
    bodyProps,
    ...rest
}: Props) {
    return (
        <Box
            w="full"
            borderWidth={1}
            borderColor="gray.100"
            rounded="2xl"
            bg="white"
            boxShadow="blue.xl"
            overflow="hidden"
        >
            <DashboardSectionCardHeader {...rest} />
            <Box w="full" bg="gray.50" {...bodyProps}>
                {children}
            </Box>
        </Box>
    )
}

function DashboardSectionCardHeader({
    icon,
    title,
    headerAction,
}: Pick<Props, 'icon' | 'title' | 'headerAction'>) {
    return (
        <SharedStack
            row
            p={4}
            pl={6}
            spacing={3}
            borderBottom="1px solid"
            borderColor="gray.100"
            w="full"
        >
            {icon}
            <SharedLabel fontSize="md" fontWeight="extrabold">
                {title}
            </SharedLabel>
            <Spacer />
            {headerAction}
        </SharedStack>
    )
}
